/**
 * "Land fehlt"-Hinweis-Chip (Adressmodell, WARTESCHLANGE Punkt 7, PR4 § 5 Punkt 5) — EXAKT
 * dasselbe Muster wie `lib/ort-typ.ts#ortTypChip()`/`StatusPill` (Warn-Pille, `tone: "warn"`,
 * gerendert als `<StatusPill meta={landChip(...)} />`, s. `pages/buchungen.tsx`
 * `<StatusPill meta={ortTypChip(...)} />`) statt einer neuen Erfindung. Backend-Grundlage bereits
 * live: `GET /api/customers/adressen-ohne-land` (Migration 425, PR2) listet serverseitig GENAU
 * die Zeilen, bei denen Straße/PLZ/Ort vollstaendig gesetzt sind, aber `*_country_code` fehlt —
 * dieselbe Bedingung hier fuer die EINZELNE Anzeigestelle (Kunden-/Vorgangsdetailseite),
 * unabhaengig von der Admin-Liste.
 *
 * "Fehlt" heisst bewusst: Strasse/PLZ/Ort sind VOLLSTAENDIG gesetzt, aber das Land fehlt — bei
 * einer komplett leeren Adresse gibt es nichts zu bemaengeln (keine Adresse hinterlegt ist ein
 * anderer, bereits anderweitig sichtbarer Zustand, kein "Land vergessen").
 */
import type { PillTone } from "../ui/format";

export interface LandChip {
  label: string;
  tone: PillTone;
}

export function landFehlt(a: { street?: string | null; zip?: string | null; city?: string | null; countryCode?: string | null }): boolean {
  const vollstaendig = Boolean(a.street?.trim()) && Boolean(a.zip?.trim()) && Boolean(a.city?.trim());
  return vollstaendig && !a.countryCode?.trim();
}

export function landChip(a: { street?: string | null; zip?: string | null; city?: string | null; countryCode?: string | null; abgeleitetAm?: string | null }): LandChip | null {
  if (landFehlt(a)) return { label: "Land fehlt", tone: "warn" };
  // Punkt 112: das Land wurde aus PLZ/Ort abgeleitet, nicht eingegeben — sichtbar, damit es geprueft wird.
  return a.countryCode?.trim() && a.abgeleitetAm ? { label: "Land abgeleitet", tone: "info" } : null;
}
